exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-breadcrumb ol[data-v-a3d43ace]{list-style:none;display:flex;flex-wrap:wrap;margin-bottom:1rem;padding:0}.custom-breadcrumb__item[data-v-a3d43ace]:not(:first-child){margin-left:7px}.custom-breadcrumb__item[data-v-a3d43ace]:not(:first-child)::before{float:left;padding-right:5px;content:\"/\"}.custom-breadcrumb__item.active[data-v-a3d43ace]{color:#333333;cursor:initial;pointer-events:none}\n", ""]);

// exports
